<template>
    <el-card>
        <div class="card-header">
            <span>今日菜品</span>
        </div>
        <TodayMenuList :menu-list="menuList" />
    </el-card>
</template>

<script>
import TodayMenuList from '@/components/TodayMenuList.vue';

export default {
    components: {
        TodayMenuList
    },
    props: {
        menuList: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="scss" scoped>
.card-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;
}
</style>